import { API_URL } from 'config';

const STORAGE_KEY = 'ref_link';
const PING_KEY = 'ref_link_ping';
const TTL_MS = 30 * 24 * 60 * 60 * 1000;
const PING_TTL_MS = 6 * 60 * 60 * 1000;

export const captureReferral = () => {
  try {
    const params = new URLSearchParams(window.location.search);
    const code = (params.get('ref') || params.get('ref_code') || params.get('r') || '')
      .trim()
      .toUpperCase()
      .slice(0, 16);

    if (!code || !/^[A-Z0-9_-]{4,16}$/.test(code)) return null;

    const stored = JSON.parse(localStorage.getItem(STORAGE_KEY) || 'null');
    if (!stored || stored.code !== code || Date.now() - stored.ts > TTL_MS) {
      localStorage.setItem(STORAGE_KEY, JSON.stringify({ code, ts: Date.now() }));
    }

    const lastPing = Number(localStorage.getItem(PING_KEY) || 0);
    if (Date.now() - lastPing > PING_TTL_MS) {
      localStorage.setItem(PING_KEY, String(Date.now()));
      fetch(`${API_URL}/auth/ref/visit`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ code }),
      }).catch(() => {});
    }

    return code;
  } catch {
    return null;
  }
};

export const getStoredReferral = () => {
  try {
    const stored = JSON.parse(localStorage.getItem(STORAGE_KEY) || 'null');
    if (!stored || !stored.code) return null;
    if (Date.now() - stored.ts > TTL_MS) {
      localStorage.removeItem(STORAGE_KEY);
      return null;
    }
    return stored.code;
  } catch {
    return null;
  }
};

export const clearStoredReferral = () => {
  try {
    localStorage.removeItem(STORAGE_KEY);
    localStorage.removeItem(PING_KEY);
  } catch {}
};
